<template>
    <div>
        <div v-for="(item, index) in logisticlist" :key="index">
            {{ item.trackNo }}
            <!-- <a v-if="item.trackNo.slice(0,2) === '1Z'" class="pull-right" target="_blank" :href="'https://www.ups.com/track?loc=zh_CN&tracknum='+item.trackNo+'&requester=WT/tracksummary'">{{getLogisticLabel(item.logisticStatus)}}</a>
            <a v-else class="pull-right" target="_blank" :href="'https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers='+item.trackNo+'&locale=en_US&cntry_code=ratetools'">{{getLogisticLabel(item.logisticStatus)}}</a> -->
            <a
                v-if="item.trackNo.slice(0, 2) === '1Z'"
                class="pull-right"
                target="_blank"
                :href="
                    'https://www.ups.com/track?loc=zh_CN&tracknum=' +
                    item.trackNo +
                    '&requester=WT/tracksummary'
                "
                >{{
                    $t("erp.b2c.official_website", { defaultValue: "去官网" })
                }}</a
            >
            <a
                v-else
                class="pull-right"
                target="_blank"
                :href="
                    'https://www.fedex.com/apps/fedextrack/?action=track&tracknumbers=' +
                    item.trackNo +
                    '&locale=en_US&cntry_code=ratetools'
                "
                >{{
                    $t("erp.b2c.official_website", { defaultValue: "去官网" })
                }}</a
            >
            <a
                class="pull-right margin-right-10"
                @click="showLogisticDetail(item.trackNo)"
                >{{
                    $t("erp.b2c.logistics_information", {
                        defaultValue: "物流信息",
                    })
                }}</a
            >
        </div>
        <compModal
            v-model="modalProps.show"
            v-bind="modalProps"
            @on-close="handleclose"
            @on-confirm="modalProps = {}"
        >
            <component
                ref="cusref"
                :is="modalProps.component"
                @on-close="handleclose"
                v-bind="modalProps"
                v-on="modalProps.on"
            ></component>
        </compModal>
    </div>
</template>

<script>
import comLogisticDetail from "./logisticdetail.vue";
export default {
    props: ["logisticlist"],
    components: { comLogisticDetail },
    data() {
        return {
            packStatus: [
                {
                    value: 0,
                    label: "UNKNOWN",
                    color: "",
                },
                {
                    value: 1,
                    label: "PRE TRANSIT",
                    color: "color-success",
                },
                {
                    value: 2,
                    label: "IN TRANSIT",
                    color: "color-primary",
                },
                {
                    value: 3,
                    label: "OUT FOR DELIVERY",
                    color: "color-warning",
                },
                {
                    value: 4,
                    label: "DELIVERED",
                    color: "",
                },
                {
                    value: 5,
                    label: "AVAILABLE FOR PICKUP",
                    color: "color-success",
                },
                {
                    value: 6,
                    label: "RETURN TO SENDER",
                    color: "color-error",
                },
                {
                    value: 7,
                    label: "FAILURE",
                    color: "color-error",
                },
                {
                    value: 8,
                    label: "CANCELLED",
                    color: "",
                },
                {
                    value: 9,
                    label: "ERROR",
                    color: "color-error",
                },
                {
                    value: 11,
                    label: "Label Created",
                    color: "",
                },
            ],
            modalProps: {
                show: false,
            },
        };
    },
    created() {},
    methods: {
        handleclose() {
            this.$emit("on-openCloseable");
            this.modalProps = {};
        },
        getLogisticLabel(val) {
            let cone = this.packStatus.filter((item) => {
                return item.value === val;
            })[0];
            return cone.label;
        },
        showLogisticDetail(trackNo) {
            this.modalProps = {
                title: this.$t("erp.b2c.logistics_information", {
                    defaultValue: "物流信息",
                }),
                show: true,
                width: 400,
                showFooter: false,
                component: "comLogisticDetail",
                trackNo,
            };
        },
    },
};
</script>
